import { useId, type InputHTMLAttributes } from "react";

/** A labelled checkbox: the whole row is a 44px-high target and the label is tied to the input. */
export function Check({ label, hint, className, ...input }: { label: string; hint?: string | undefined } & Omit<InputHTMLAttributes<HTMLInputElement>, "type" | "id">) {
  const id = useId();
  return (
    <div className={["cc-check", className].filter(Boolean).join(" ")}>
      <input id={id} type="checkbox" {...input} />
      <label htmlFor={id}>
        <span className="cc-check__title">{label}</span>
        {hint ? <span className="cc-muted"> {hint}</span> : null}
      </label>
    </div>
  );
}
